import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconTranslateStyle0 = gravityIconIndividualCss;

const GravityIconTranslate = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '9ed4452d196135829a5a254eccf034ec866c2c86', color: this.color, size: this.size }, h("svg", { key: '8fc025287a2731147a1bd136e394e2588e3f9fb9', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '74f6f445141f0dd1137d8d471ced500b06fd4fa8', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M8.75 2.5h-1.5V4H4v1.5h1.146A8.683 8.683 0 0 0 6.86 8.114a9.36 9.36 0 0 1-2.139 1.19l.558 1.392A10.78 10.78 0 0 0 8.013 9.12c.882.646 1.879 1.145 2.959 1.577l.556-1.392c-.894-.358-1.693-.751-2.394-1.229A10.574 10.574 0 0 0 10.876 5.5H12V4H8.75V2.5Zm-.77 4.614c.45-.48.851-1.017 1.199-1.614h-2.37c.33.622.72 1.152 1.17 1.614Zm7.688 9.386L16.2 18h1.6l-2.123-5.934c-.395-1.106-1.959-1.106-2.354 0L11.2 18h1.6l.532-1.5h2.336Zm-.357-1-.81-2.27-.812 2.27h1.622Z", fill: "currentColor" }), h("path", { key: '382aa9b05a5804afc3059bb4b95e533a82ff1b89', d: "M16 9V7a1 1 0 0 0-1-1h-2v1h2v2h1ZM6 13v2a1 1 0 0 0 1 1h2v-1H7v-2H6Z", fill: "currentColor" }))));
    }
};
GravityIconTranslate.style = GravityIconTranslateStyle0;

export { GravityIconTranslate as gravity_icon_translate };

//# sourceMappingURL=gravity-icon-translate.entry.js.map